import { useState, type ReactNode } from 'react';
import { TermsModal } from './terms-modal';

interface Props {
    children?: ReactNode;
    className?: string;
}

/**
 * Inline link that opens the Terms & Conditions modal. Useful in footers,
 * sign-up flows, or anywhere a quick T&C affordance is needed without
 * manually wiring modal state.
 */
export function TermsLink({ children = 'Terms & Conditions', className = '' }: Props) {
    const [open, setOpen] = useState(false);
    return (
        <>
            <button
                type="button"
                onClick={() => setOpen(true)}
                className={
                    'inline font-medium text-brand-sky-500 underline-offset-2 hover:text-brand-navy hover:underline ' +
                    className
                }
            >
                {children}
            </button>
            <TermsModal open={open} onClose={() => setOpen(false)} />
        </>
    );
}
